import React from 'react';
import { HubspotSignUp } from '../../components/HubspotSignUp/HubspotSignUp';
import { ScopesRequired } from '../../components/ScopesRequired';
import routing from '../../services/routing';
import qs from 'query-string';

// Only allowed for staff with the relevant admin permissions
export const HubspotSignUpRoute = () => (
    <ScopesRequired allowedScopes={['admin:createcompany']}>
        <HubspotSignUp formId={qs.parse(routing.location.search).formId as string | undefined} />
    </ScopesRequired>
);
